import { TestIdDomain } from 'constants/testIds';

const formsTestIdsScope = {
  FORMS_EDIT_FORM: 'forms-edit-form',
  DYNAMIC_FIELD_EDIT_DELETE: 'dynamic-field-edit-delete',
  HAND_WRITING_SIGNATURE: 'hand-writing-signature',
  DYNAMIC_FIELD_ITEMS_LIST: 'dynamic-field-items-list',
  DYNAMIC_FIELD_NOTARY_OPTIONS: 'dynamic-field-notary-options',
  DYNAMIC_FIELD_OPTIONS_LAYOUT: 'dynamic-field-options-layout',
  RATE_CURRENCY_OPTIONS: 'rate-currency-options',
  STYLE_OPTIONS_VIEW: 'style-options-view',
  TODAYS_DATE_PLUS_NUMBER: 'todays-date-plus-number',
  STYLE_VIEW_OPTIONS: 'style-view-options',
  SIGNATURE: 'signature',
  COMPANY_AUTHORIZED_SIGNER: 'company-authorized-signer',
  SECURITY_GROUP_SIGNER: 'security-group-signer',
  SIGNING_RULE_MODAL: 'signing-rule-modal',
  SIGNING_RULES_TABLE: 'signing-rules-table',
};

export const formsTestIds = {
  // DynamicFieldHandWritingSignatureOptions
  DYNAMIC_FIELD_HAND_WRITING_SIGNATURE_OPTIONS: `${TestIdDomain.FORMS}.dynamic-field-hand-writing-signature-options`,
  HAND_WRITING_EXCLUDE_SIGNATURE_LINE_CHECKBOX: `${formsTestIdsScope.HAND_WRITING_SIGNATURE}.exclude-signature-line-checkbox`,
  HAND_WRITING_EXCLUDE_DATE_CHECKBOX: `${formsTestIdsScope.HAND_WRITING_SIGNATURE}.exclude-date-checkbox`,

  // DynamicFieldItemView
  DYNAMIC_FIELD_ITEM_VIEW: `${TestIdDomain.FORMS}.dynamic-field-item-view`,

  // DynamicFieldNotaryOptionsView
  DYNAMIC_FIELD_NOTARY_OPTIONS_VIEW: `${TestIdDomain.FORMS}.dynamic-field-notary-options-view`,
  NOTARY_OPTIONS_ACTOR_SELECT: `${formsTestIdsScope.DYNAMIC_FIELD_NOTARY_OPTIONS}.actor-select`,
  NOTARY_OPTIONS_DOCUMENT_TITLE_INPUT: `${formsTestIdsScope.DYNAMIC_FIELD_NOTARY_OPTIONS}.document-title-input`,

  // DynamicFieldItemsList
  DYNAMIC_FIELD_ITEMS_LIST_SEARCH_INPUT: `${formsTestIdsScope.DYNAMIC_FIELD_ITEMS_LIST}.search-input`,

  // DynamicFieldEditDeleteOptionsView
  DYNAMIC_FIELD_EDIT_DELETE_CHANGE_FIELD_BUTTON: `${formsTestIdsScope.DYNAMIC_FIELD_EDIT_DELETE}.change-field-button`,
  DYNAMIC_FIELD_EDIT_DELETE_EDIT_FORMATTING_BUTTON: `${formsTestIdsScope.DYNAMIC_FIELD_EDIT_DELETE}.edit-formatting-button`,
  DYNAMIC_FIELD_EDIT_DELETE_DELETE_BUTTON: `${formsTestIdsScope.DYNAMIC_FIELD_EDIT_DELETE}.delete-button`,

  // DynamicFieldOptionsLayout
  DYNAMIC_FIELD_OPTIONS_LAYOUT_CANCEL_BUTTON: `${formsTestIdsScope.DYNAMIC_FIELD_OPTIONS_LAYOUT}.cancel-button`,
  DYNAMIC_FIELD_OPTIONS_LAYOUT_SAVE_BUTTON: `${formsTestIdsScope.DYNAMIC_FIELD_OPTIONS_LAYOUT}.save-button`,

  // DynamicFieldRateCurrencyOptions
  DYNAMIC_FIELD_RATE_CURRENCY_OPTIONS: `${TestIdDomain.FORMS}.dynamic-field-rate-currency-options`,
  RATE_CURRENCY_PREFIX_SELECT: `${formsTestIdsScope.RATE_CURRENCY_OPTIONS}.prefix-select`,
  RATE_CURRENCY_POSTFIX_SELECT: `${formsTestIdsScope.RATE_CURRENCY_OPTIONS}.postfix-select`,

  // DynamicFieldStyleOptionsView
  DYNAMIC_FIELD_STYLE_OPTIONS_VIEW: `${TestIdDomain.FORMS}.dynamic-field-style-options-view`,
  STYLE_OPTIONS_INVERSE_VALUE_CHECKBOX: `${formsTestIdsScope.STYLE_OPTIONS_VIEW}.inverse-value-checkbox`,
  STYLE_OPTIONS_WITH_LABEL_CHECKBOX: `${formsTestIdsScope.STYLE_OPTIONS_VIEW}.with-label-checkbox`,
  STYLE_OPTIONS_LABEL_INPUT: `${formsTestIdsScope.STYLE_OPTIONS_VIEW}.label-input`,
  STYLE_OPTIONS_DATE_ONLY_CHECKBOX: `${formsTestIdsScope.STYLE_OPTIONS_VIEW}.date-only-checkbox`,
  STYLE_OPTIONS_POA_VERBIAGE_CHECKBOX: `${formsTestIdsScope.STYLE_OPTIONS_VIEW}.poa-verbiage-checkbox`,
  STYLE_OPTIONS_UPPERCASE_CHECKBOX: `${formsTestIdsScope.STYLE_OPTIONS_VIEW}.uppercase-checkbox`,
  STYLE_OPTIONS_SPELLED_OUT_CHECKBOX: `${formsTestIdsScope.STYLE_OPTIONS_VIEW}.spelled-out-checkbox`,
  STYLE_OPTIONS_PREFIX_SELECT: `${formsTestIdsScope.STYLE_OPTIONS_VIEW}.prefix-select`,
  STYLE_OPTIONS_POSTFIX_SELECT: `${formsTestIdsScope.STYLE_OPTIONS_VIEW}.postfix-select`,
  STYLE_OPTIONS_THOUSANDS_SEPARATOR_CHECKBOX: `${formsTestIdsScope.STYLE_OPTIONS_VIEW}.thousands-separator-checkbox`,
  STYLE_OPTIONS_TAG_SELECT: `${formsTestIdsScope.STYLE_OPTIONS_VIEW}.tag-select`,
  STYLE_OPTIONS_FLOAT_SELECT: `${formsTestIdsScope.STYLE_OPTIONS_VIEW}.float-select`,

  // DynamicFieldTodaysDatePlusNumberView
  DYNAMIC_FIELD_TODAYS_DATE_PLUS_NUMBER_VIEW: `${TestIdDomain.FORMS}.dynamic-field-todays-date-plus-number-view`,
  TODAYS_DATE_DATE_ONLY_CHECKBOX: `${formsTestIdsScope.TODAYS_DATE_PLUS_NUMBER}.date-only-checkbox`,

  // StyleViewOptions
  STYLE_VIEW_BOLD_CHECKBOX: `${formsTestIdsScope.STYLE_VIEW_OPTIONS}.bold-checkbox`,
  STYLE_VIEW_CHECKBOX_RENDER_TYPE_RADIO: `${formsTestIdsScope.STYLE_VIEW_OPTIONS}.checkbox-render-type-radio`,
  STYLE_VIEW_FONT_FAMILY_SELECT: `${formsTestIdsScope.STYLE_VIEW_OPTIONS}.font-family-select`,
  STYLE_VIEW_FONT_SIZE_SELECT: `${formsTestIdsScope.STYLE_VIEW_OPTIONS}.font-size-select`,
  STYLE_VIEW_HORIZONTAL_ALIGNMENT_SELECT: `${formsTestIdsScope.STYLE_VIEW_OPTIONS}.horizontal-alignment-select`,
  STYLE_VIEW_VERTICAL_ALIGNMENT_SELECT: `${formsTestIdsScope.STYLE_VIEW_OPTIONS}.vertical-alignment-select`,

  // EditFormModal
  WITH_PAGE_NUMBERS_CHECKBOX: `${TestIdDomain.FORMS}.with-page-numbers-checkbox`,
  FORMS_EDIT_FORM_FORM_APPLICATION_TYPE_SELECT: `${formsTestIdsScope.FORMS_EDIT_FORM}.form-application-type-select`,
  FORMS_EDIT_FORM_DISCLOSURE_TYPE_SELECT: `${formsTestIdsScope.FORMS_EDIT_FORM}.disclosure-type-select`,
  FORMS_EDIT_FORM_PURPOSE_TYPE_SELECT: `${formsTestIdsScope.FORMS_EDIT_FORM}.purpose-type-select`,
  FORMS_EDIT_FORM_FORM_PURPOSE_SELECT: `${formsTestIdsScope.FORMS_EDIT_FORM}.form-purpose-select`,
  FORMS_EDIT_FORM_SUBMIT_BUTTON: `${formsTestIdsScope.FORMS_EDIT_FORM}.submit-button`,
  FORMS_EDIT_FORM_RESET_OVERRIDE_BUTTON: `${formsTestIdsScope.FORMS_EDIT_FORM}.reset-override-button`,
  FORMS_EDIT_FORM_NAME_INPUT: `${formsTestIdsScope.FORMS_EDIT_FORM}.name-input`,
  FORMS_EDIT_FORM_USE_CURRENT_FILE_CHECKBOX: `${formsTestIdsScope.FORMS_EDIT_FORM}.use-current-file-checkbox`,
  FORMS_EDIT_FORM_IS_UPLOAD_PDF_CHECKBOX: `${formsTestIdsScope.FORMS_EDIT_FORM}.is-upload-pdf-checkbox`,

  // FormEditorHeader
  FORMS_FORM_EDITOR_HEADER: 'forms-form-editor.header',

  // PrePreviewFormBasedOnLoanModal
  PRE_PREVIEW_LOAN_FORM_SUBMIT_BUTTON: 'pre-preview-loan-form.submit-button',

  // PrePreviewFormModal
  PRE_PREVIEW_FORM_SUBMIT_BUTTON: 'pre-preview-form.submit-button',
  PRE_PREVIEW_FORM_COBORROWERS_SELECT: 'pre-preview-form.coborrowers-select',
  PRE_PREVIEW_FORM_NONBORROWERS_SELECT: 'pre-preview-form.nonborrowers-select',

  PRISM_EXPORT_SIGNERS_SUBMIT_BUTTON: 'prism-export-signers.submit-button',
  PRISM_EXPORT_SIGNERS_COBORROWERS_SELECT: 'prism-export-signers.coborrowers-select',
  PRISM_EXPORT_SIGNERS_NONBORROWERS_SELECT: 'prism-export-signers.nonborrowers-select',

  // Signature
  IS_MULTIPLE_OPTIONS: `${TestIdDomain.FORMS}.is-multiple-options`,
  SIGNATURE_MODE_SINGLE_BUTTON: `${formsTestIdsScope.SIGNATURE}.mode-single-button`,
  SIGNATURE_MODE_MULTI_BUTTON: `${formsTestIdsScope.SIGNATURE}.mode-multi-button`,
  SIGNATURE_TYPE_SELECT: `${formsTestIdsScope.SIGNATURE}.type-select`,
  SIGNATURE_SIGNER_SELECT: `${formsTestIdsScope.SIGNATURE}.signer-select`,
  SIGNATURE_SELECTION_REQUIREMENT_SELECT: `${formsTestIdsScope.SIGNATURE}.selection-requirement-select`,
  SIGNATURE_CANCEL_BUTTON: `${formsTestIdsScope.SIGNATURE}.cancel-button`,
  SIGNATURE_SAVE_BUTTON: `${formsTestIdsScope.SIGNATURE}.save-button`,
  getSignatureParentTagSelectTestId: index =>
    `${formsTestIdsScope.SIGNATURE}.parent-tag-select-${index}`,
  getSignatureChildTagSelectTestId: index =>
    `${formsTestIdsScope.SIGNATURE}.child-tag-select-${index}`,

  // CompanyAuthorizedSignerConfig
  COMPANY_AUTHORIZED_SIGNER_MODE_SELECT: `${formsTestIdsScope.COMPANY_AUTHORIZED_SIGNER}.mode-select`,
  COMPANY_AUTHORIZED_SIGNER_DESIGNATED_SIGNER_SELECT: `${formsTestIdsScope.COMPANY_AUTHORIZED_SIGNER}.designated-signer-select`,

  // SecurityGroupSignerConfig
  SECURITY_GROUP_SIGNER_SELECT: `${formsTestIdsScope.SECURITY_GROUP_SIGNER}.security-group-select`,

  // SigningRuleModal
  SIGNING_RULE_MODAL_CAPACITY_SELECT: `${formsTestIdsScope.SIGNING_RULE_MODAL}.capacity-select`,
  SIGNING_RULE_MODAL_CANCEL_BUTTON: `${formsTestIdsScope.SIGNING_RULE_MODAL}.cancel-button`,
  SIGNING_RULE_MODAL_SAVE_BUTTON: `${formsTestIdsScope.SIGNING_RULE_MODAL}.save-button`,

  // SigningRulesTable
  SIGNING_RULES_TABLE_ADD_RULE_BUTTON: `${formsTestIdsScope.SIGNING_RULES_TABLE}.add-rule-button`,
  getSigningRulesTableEditTestId: index =>
    `${formsTestIdsScope.SIGNING_RULES_TABLE}.edit-button-${index}`,
  getSigningRulesTableDeleteTestId: index =>
    `${formsTestIdsScope.SIGNING_RULES_TABLE}.delete-button-${index}`,

  // EditFormModal (inline)
  FORMS_EDIT_FORM_FORMS_EDIT_FORM_AUTOCOMPLETE_SELECT: `${formsTestIdsScope.FORMS_EDIT_FORM}.forms-edit-form-autocomplete-select`,
  FORMS_EDIT_FORM_FORMS_EDIT_FORM_AUTOCOMPLETE_INPUT: `${formsTestIdsScope.FORMS_EDIT_FORM}.forms-edit-form-autocomplete-input`,
};
